export var GLOBAL_INTERESTS_FILTERS = 'GLOBAL_INTERESTS_FILTERS';
export var INTEREST_SUMMARY = 'INTEREST_SUMMARY';
export var INTEREST_ITEMS = 'INTEREST_ITEMS';